/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_RevokedInputs */

const en_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not granted`)
};

const de_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht erteilt`)
};

const fr_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non accorde`)
};

const es_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No otorgado`)
};

const it_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non concesso`)
};

const nl_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet verleend`)
};

const pl_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udzielono`)
};

const fi_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei myonnetty`)
};

const da_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke givet`)
};

const sv_consent_settings_revoked = /** @type {(inputs: Consent_Settings_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte beviljat`)
};

/**
* | output |
* | --- |
* | "Not granted" |
*
* @param {Consent_Settings_RevokedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_revoked = /** @type {((inputs?: Consent_Settings_RevokedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_RevokedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_revoked(inputs)
	if (locale === "fr") return fr_consent_settings_revoked(inputs)
	if (locale === "es") return es_consent_settings_revoked(inputs)
	if (locale === "it") return it_consent_settings_revoked(inputs)
	if (locale === "nl") return nl_consent_settings_revoked(inputs)
	if (locale === "pl") return pl_consent_settings_revoked(inputs)
	if (locale === "fi") return fi_consent_settings_revoked(inputs)
	if (locale === "da") return da_consent_settings_revoked(inputs)
	if (locale === "sv") return sv_consent_settings_revoked(inputs)
	return en_consent_settings_revoked(inputs)
});